import React, { FC } from 'react';

import GeneralLayout from 'core/react/layout/GeneralLayout';
import { TepOfficersNotifications } from 'components/organisms/tep/officers-notifications';

export const TepOfficersNotificationsPage: FC = () => (
  <GeneralLayout>
    <TepOfficersNotifications />
  </GeneralLayout>
);
